import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Divider,
  TimePicker,
  Radio,
  Input,
  Flex,
  Checkbox,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { getStockItems } from '../../../network/materialRequest';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getWarehouse } from '../../../network/warehouse';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getSearchApi, getSearchApiFilters } from '../../../network/itemList';
import { PlusOutlined } from '@ant-design/icons';
import { MdDelete, MdLocalFireDepartment } from 'react-icons/md';
import {
  addStockEntry,
  getMaterialDetailsInStock,
  getStockEntryDetails,
  updateStockEntry,
} from '../../../network/stockEntry';
import {
  addDepartmentHr,
  getDepartmentHrDetails,
  updateDepartmentHr,
} from '../../../network/departmentHr';
import HeadingApp from '../../../hooks/HeadingApp';
const AddDepartmentHr = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const { companyName } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  //
  const { mutate: onAddStockEntry } = useMutation({
    mutationKey: ['addStockEntry'],
    mutationFn: (body) =>
      edit ? updateDepartmentHr(body, id) : addDepartmentHr(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getDepartmentHr] });
      form.resetFields();
      navigate('/department-hr');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const { data: departmentHrDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getDepartmentHr, id],
    queryFn: () => getDepartmentHrDetails(id),
    enabled: !!edit,
  });
  const filterDepartment = [['Department', 'is_group', '=', 1]];
  const { data: department } = useQuery({
    queryKey: [queryKeys.getAccountSearchDepartment],
    queryFn: () => getSearchApi('Department'),
    keepPreviousData: true,
  });
  const { data: payrollCostCenter } = useQuery({
    queryKey: [queryKeys.getAccountSearchCostCenter],
    queryFn: () => getSearchApi('Cost Center'),
    keepPreviousData: true,
  });
  const { data: User } = useQuery({
    queryKey: [queryKeys.getAccountSearchUser],
    queryFn: () => getSearchApi('User'),
    keepPreviousData: true,
  });
  useEffect(() => {
    if (edit && departmentHrDetails) {
      form.setFieldsValue({
        ...departmentHrDetails?.data,
        leave_approvers: departmentHrDetails?.data?.leave_approvers?.length
          ? departmentHrDetails?.data?.leave_approvers
          : [{}],
        expense_approvers: departmentHrDetails?.data?.expense_approvers?.length
          ? departmentHrDetails?.data?.expense_approvers
          : [{}],
      });
    } else {
      form.resetFields();
    }
  }, [edit, departmentHrDetails, form]);
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddStockEntry({
      ...values,
      company: companyName,
      is_group: values?.is_group ? 1 : 0,
      disabled: values?.disabled ? 1 : 0,
    });
  };
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.Inventory}
        subTitle={edit ? t.editDepartment : t.addDepartment}
        path="/department-hr"
      /> */}
      <HeadingApp
        nameTab={t.HR}
        title={t.department}
        subTitle={edit ? t.editDepartment : t.addDepartment}
        icon={<MdLocalFireDepartment />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-department-hr"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            leave_approvers: [{}],
            expense_approvers: [{}],
          }}
          style={{
            marginTop: '20px',
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="department_name"
                    label={t.departmentName}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder={t.departmentName} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="parent_department"
                    label={t.parentDepartment}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.parentDepartment}
                      style={{ width: '100%' }}
                      popupMatchSelectWidth={false}
                      options={department?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="payroll_cost_center"
                    label={t.payrollCostCenter}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.payrollCostCenter}
                      style={{ width: '100%' }}
                      popupMatchSelectWidth={false}
                      options={payrollCostCenter?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} md={12} xl={8} xxl={8}>
                  <Form.Item name="disabled" valuePropName="checked">
                    <Checkbox>{t.disabled}</Checkbox>
                  </Form.Item>
                </Col>
                <Col xs={12} md={12} xl={8} xxl={8}>
                  <Form.Item name="is_group" valuePropName="checked">
                    <Checkbox>{t.isgroup}</Checkbox>
                  </Form.Item>
                </Col>
                <Divider orientation="left">{t.ExpenseApprovers}</Divider>
                <Col span={24} className="items-form-add">
                  <Form.List name="expense_approvers" style={{ width: '100%' }}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <>
                            <Flex
                              key={key}
                              justify="space-between"
                              align="center"
                              gap="5px"
                              style={{
                                width: '100%',
                              }}
                            >
                              <Form.Item
                                name={[name, 'approver']}
                                label={t.approver}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                              >
                                <Select
                                  placeholder={t.approver}
                                  style={{ width: '100%' }}
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.label ?? '')
                                      .toLocaleLowerCase()
                                      .includes(input.toLocaleLowerCase())
                                  }
                                  filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '')
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? '').toLowerCase()
                                      )
                                  }
                                  popupMatchSelectWidth={false}
                                  options={User?.message?.map((item) => ({
                                    value: item?.value,
                                    label: item?.value,
                                  }))}
                                />
                              </Form.Item>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  fontSize: '15px',
                                  margin: '0 10px',
                                }}
                              >
                                {fields.length > 1 && (
                                  <Button
                                    type="text"
                                    onClick={() => remove(name)}
                                    danger
                                    icon={<MdDelete color="red" />}
                                  />
                                )}
                                <Button
                                  type="text"
                                  onClick={() => add()}
                                  icon={<PlusOutlined color="#1890ff" />}
                                />
                              </div>
                            </Flex>
                          </>
                        ))}
                      </>
                    )}
                  </Form.List>
                </Col>
                <Divider orientation="left">{t.leaveApprover}</Divider>
                <Col span={24} className="items-form-add">
                  <Form.List name="leave_approvers" style={{ width: '100%' }}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <>
                            <Flex
                              key={key}
                              justify="space-between"
                              align="center"
                              gap="5px"
                              style={{
                                width: '100%',
                              }}
                            >
                              <Form.Item
                                name={[name, 'approver']}
                                label={t.approver}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                              >
                                <Select
                                  placeholder={t.approver}
                                  style={{ width: '100%' }}
                                  showSearch
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.label ?? '')
                                      .toLocaleLowerCase()
                                      .includes(input.toLocaleLowerCase())
                                  }
                                  filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '')
                                      .toLowerCase()
                                      .localeCompare(
                                        (optionB?.label ?? '').toLowerCase()
                                      )
                                  }
                                  popupMatchSelectWidth={false}
                                  options={User?.message?.map((item) => ({
                                    value: item?.value,
                                    label: item?.value,
                                  }))}
                                />
                              </Form.Item>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  fontSize: '15px',
                                  margin: '0 10px',
                                }}
                              >
                                {fields.length > 1 && (
                                  <Button
                                    type="text"
                                    onClick={() => remove(name)}
                                    danger
                                    icon={<MdDelete color="red" />}
                                  />
                                )}
                                <Button
                                  type="text"
                                  onClick={() => add()}
                                  icon={<PlusOutlined color="#1890ff" />}
                                />
                              </div>
                            </Flex>
                          </>
                        ))}
                      </>
                    )}
                  </Form.List>
                </Col>
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t.Cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddDepartmentHr;
